import { useShallow } from "zustand/react/shallow";
import { StoreApi, UseBoundStore } from "zustand";

export function useStoreSelector<T extends object, K extends keyof T>(
  store: UseBoundStore<StoreApi<T>>,
  ...keys: K[]
): Pick<T, K> {
  return store(
    useShallow((state) => {
      const selectedState = {} as Pick<T, K>;
      keys.forEach((key) => {
        selectedState[key] = state[key];
      });
      return selectedState;
    }),
  );
}
